export enum AccessGroupEnum {
    OWNER = 'OWNER',
    NON_MEMBER = 'NON_MEMBER',
    EMPLOYEE = 'EMPLOYEE',
    SAILOR = 'SAILOR',
    GUEST = 'GUEST',
    SERVICE_PROVIDER = 'SERVICE_PROVIDER'

}
